"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zod_1 = require("zod");
var GlobalPlaceFilterSchema = zod_1.z.object({
    checkinDate: zod_1.z.string().optional(),
    checkoutDate: zod_1.z.string().optional(),
    rooms: zod_1.z.array(zod_1.z.object({
        /** [해외숙소] 성인 수 */
        adult: zod_1.z.number(),
        /** [해외숙소] 아동 나이 */
        child: zod_1.z.array(zod_1.z.number()),
    })),
});
var UpdateSessionLocalFiltersRequestSchema = zod_1.z.object({
    checkinDate: zod_1.z.string().nullish(),
    checkoutDate: zod_1.z.string().nullish(),
    prevCheckinDate: zod_1.z.string().nullish(),
    prevCheckoutDate: zod_1.z.string().nullish(),
    capacityAdult: zod_1.z.number().nullish(),
    capacityChild: zod_1.z.number().nullish(),
    capacityChildAges: zod_1.z.array(zod_1.z.number()).nullish(),
    globalPlaceFilter: GlobalPlaceFilterSchema.nullish(),
    globalPrevCheckinDate: zod_1.z.string().nullish(),
    globalPrevCheckoutDate: zod_1.z.string().nullish(),
});
var UpdateSessionLocalFiltersResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
